import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import store from '@plat/store'
import router from '@plat/router'

const gaKey = store.state.config.googleAnalytics.key

if (gaKey) {
  Vue.use(VueAnalytics, {
    id: gaKey,
    router,
    autoTracking: {
      pageviewTemplate (route) {
        return {
          title: document.title,
          location: window.location.href,
          page: window.location.pathname + window.location.hash
        }
      }
    }
  })
}
